export default __webpack_public_path__ + "static/media/login.820cf094.png";